<template>
  <footer class="py-20 text-white bg-gray-900">
    <div class="container px-4 mx-auto md:px-6">
      <div class="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-5 md:gap-12">
        <div class="lg:col-span-2">
          <a href="/" class="inline-block mb-6">
            <span class="text-3xl font-['Pacifico'] text-white">Ticket Job Hub</span>
          </a>
          <p class="mb-8 text-gray-400">Connecting talent with opportunities in the cinema industry. Find your next
            role in theater operations, management, or technical positions.</p>
          <div class="flex space-x-4">
            <a v-for="(social, index) in socials" :key="index" href="#"
              class="flex items-center justify-center w-10 h-10 transition-colors duration-300 bg-gray-800 rounded-full hover:bg-red-600">
              <i :class="social.icon"></i>
            </a>
          </div>
        </div>
        <div>
          <h4 class="mb-6 text-lg font-semibold">Quick Links</h4>
          <ul class="space-y-4">
            <li v-for="(link, index) in quickLinks" :key="index">
              <a href="#" class="text-gray-400 transition-colors duration-300 hover:text-white">{{ link }}</a>
            </li>
          </ul>
        </div>
        <div>
          <h4 class="mb-6 text-lg font-semibold">Job Seeker</h4>
          <ul class="space-y-4">
            <li v-for="(link, index) in jobSeekerLinks" :key="index">
              <a href="#" class="text-gray-400 transition-colors duration-300 hover:text-white">{{ link }}</a>
            </li>
          </ul>
        </div>
        <div>
          <h4 class="mb-6 text-lg font-semibold">Newsletter</h4>
          <p class="mb-4 text-gray-400">Subscribe to get the latest job updates and career tips.</p>
          <div class="flex flex-col gap-2 sm:flex-row">
            <input type="email" placeholder="Your email"
              class="w-full sm:flex-1 px-4 py-2 bg-gray-800 border-none text-white !rounded-button sm:rounded-r-none">
            <button
              class="px-6 py-2 bg-red-600 text-white font-medium hover:bg-red-700 transition-colors duration-300 !rounded-button rounded-l-none whitespace-nowrap">Subscribe</button>
          </div>
        </div>
      </div>
      <div class="pt-8 mt-12 text-center border-t border-gray-800">
        <p class="text-gray-400">&copy; 2025 TJH - Ticket Job Hub. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'TheFooter',
  data(){
    return{
      socials: [
        { icon: 'fab fa-facebook-f' },
        { icon: 'fab fa-twitter' },
        { icon: 'fab fa-linkedin-in' },
        { icon: 'fab fa-instagram' }
      ],
      quickLinks: ['About Us', 'Contact', 'Privacy Policy', 'Terms of Service'],
      jobSeekerLinks: ['Browse Jobs', 'Career Resources', 'Resume Tips', 'Job Alerts'] 
    }
  }
}
</script>